import { useTranslate } from 'ra-core'
import { FC } from 'react'
import { useFormState } from 'react-final-form'
import InputAccordion from '../common/InputAccordion'
import { useBlockSource } from '../useBlockSource'
import ExpoStandResourcesManager from './ExpoStandResourcesManager'

interface PropTypes {
  disabled?: boolean
}

const ResourcesFields: FC<PropTypes> = ({ disabled }) => {
  const translate = useTranslate()
  const source = useBlockSource('resources')
  const standId = useFormState().values?.id

  if (!source) return null
  return (
    <InputAccordion title={translate('Resources')} source={source}>
      <ExpoStandResourcesManager standId={standId} disabled={disabled} />
    </InputAccordion>
  )
}

export default ResourcesFields
